module.exports = __webpack_public_path__ + "img/8d0eefe4067b455450810c04c9f646d9.e7c059c6.jpeg";